import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Box } from '@mui/material';
import { withStyles } from '@mui/styles';
import LOCATION_TYPE from '../enum/location_type';

const styles = (theme) => ({
  tabsContainer: {
    display: 'inline-flex',
    width: 'fit-content',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    border: '1px solid #e0e0e0',
    padding: '4px',
    position: 'absolute',
    zIndex: 1000,
    '& .MuiTabs-root': {
      minHeight: 'auto',
    },
    '& .MuiTabs-flexContainer': {
      gap: '4px',
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  positionTopLeft: {
    top: '16px',
    left: '16px',
  },
  positionTopRight: {
    top: '16px',
    right: '16px',
  },
  positionInline: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
  },
  deliveryTab: {
    minWidth: 80,
    textTransform: 'none',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#666666',
    padding: '8px 16px',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
    '&.Mui-selected': {
      color: '#0a5d66',
      fontWeight: 600,
      backgroundColor: '#f0f9fa',
    },
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
});

class DeliveryTypeTabs extends React.Component {
  getTabIndexFromLocationType = (locationTypeId) => {
    if (!locationTypeId) return 0;
    const deliveryTypes = this.getAvailableDeliveryTypes();
    const index = deliveryTypes.findIndex((type) => type.id === locationTypeId);
    return index >= 0 ? index : 0;
  };

  getAvailableDeliveryTypes = () => {
    const { locationtype } = this.props;

    if (locationtype && Array.isArray(locationtype) && locationtype.length > 0) {
      return locationtype;
    }

    return [
      { id: LOCATION_TYPE.Kiosk, label: 'Kiosk' },
      { id: LOCATION_TYPE.Counter, label: 'Counter' },
      { id: LOCATION_TYPE.Bedside, label: 'Bedside' },
      { id: LOCATION_TYPE.Courier, label: 'Courier' },
      { id: LOCATION_TYPE.Curbside, label: 'Curbside' },
    ];
  };

  handleTabChange = (event, newValue) => {
    const deliveryTypes = this.getAvailableDeliveryTypes();
    const selectedType = deliveryTypes[newValue];
    
    if (selectedType && this.props.onLocationTypeChange) {
      this.props.onLocationTypeChange(selectedType.id);
    }
    
  };

  render() {
    const { classes, onLocationTypeChange, position = 'topLeft' } = this.props;
    const deliveryTypes = this.getAvailableDeliveryTypes();
    const value = this.getTabIndexFromLocationType(this.props.selectedLocationTypeId);

    if (!onLocationTypeChange) {
      return null;
    }

    const positionClass = position === 'topRight' 
      ? classes.positionTopRight 
      : position === 'inline' 
        ? classes.positionInline 
        : classes.positionTopLeft;

    return (
      <Box className={`${classes.tabsContainer} ${positionClass}`}>
        <Tabs
          value={value}
          onChange={this.handleTabChange}
          variant="standard"
          aria-label="delivery type tabs"
        >
          {deliveryTypes.map((type, index) => (
            <Tab
              key={type.id}
              label={type.label}
              className={classes.deliveryTab}
              aria-label={`Switch to ${type.label} delivery`}
            />
          ))}
        </Tabs>
      </Box>
    );
  }
}

DeliveryTypeTabs.propTypes = {
  selectedLocationTypeId: PropTypes.string,
  onLocationTypeChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  locationtype: PropTypes.array,
  position: PropTypes.oneOf(['topLeft', 'topRight', 'inline']),
};

export default withStyles(styles)(DeliveryTypeTabs);



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/DeliveryTypeTabs.js